import type { FunctionComponent, ReactElement } from 'react';

import { useChatSlice } from '../../../../store/slices/chat/selectors';
import { Chat } from '../../../chat/chat/Chat';
import { ChatFooterConnected } from '../../../chat/chat/footer/ChatFooterConnected';
import { MessagesWrapperConnected } from '../../../chat/chat/messages/messagesWrapper/MessagesWrapperConnected';

export const NavPageChatConnected: FunctionComponent = (): ReactElement => {
  const gameChatMessages = useChatSlice.getGameChatMessages();

  return (
    <Chat
      chatFooter={<ChatFooterConnected isGameChat />}
      messagesWrapper={<MessagesWrapperConnected messages={gameChatMessages} />}
    />
  );
};
